import styled from "styled-components";

export const Container = styled("div")`
  margin: 20px auto;
  max-width: 1000px;
  padding: 40px;
  text-align: center;
`;

export const ItemList = styled("ul")`
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  margin: 0 20px;
  padding: 0;
  & > :last-child {
    flex-grow: 10;
  }
`;

export const LinkItem = styled("a")`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

export const PaginationWrapper = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
`;
